import { render } from "./AppMenuNavItem.vue?vue&type=template&id=45e8df3c&scoped=true"
import script from "./AppMenuNavItem.vue?vue&type=script&lang=js"
export * from "./AppMenuNavItem.vue?vue&type=script&lang=js"

import "./AppMenuNavItem.vue?vue&type=style&index=0&id=45e8df3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e8df3c"]])

export default __exports__